import React, { useState } from 'react';
import { Section } from './ui';
export const Faq = () => {
  const faqs = [{
    q: '¿Esto es solo otro recetario más?',
    a: 'No. Pasteles Sin Culpa no es una lista de recetas copiadas. Es un sistema paso a paso que te enseña cómo lograr humedad, textura y estructura en pasteles sin gluten, sin lácteos y sin azúcar refinada.'
  }, {
    q: '¿Y si ya probé muchas recetas sin gluten y fallaron?',
    a: 'Justamente por eso existe este método. Muchas recetas fallan porque intentan copiar la repostería tradicional cambiando ingredientes. Acá el enfoque es distinto: se trabaja la estructura del pastel desde el inicio.'
  }, {
    q: '¿Necesito ingredientes raros o caros?',
    a: 'No. La idea es ayudarte a aprovechar mejor ingredientes accesibles y entender cómo combinarlos. También recibes una guía de harinas y endulzantes para evitar gastar de más.'
  }, {
    q: '¿Funciona si no soy buena horneando?',
    a: 'Sí. El e-book está pensado para personas comunes, no para pasteleras profesionales. Cada receta está explicada paso a paso.'
  }, {
    q: '¿Cómo recibo el e-book?',
    a: 'Después de la compra recibes el acceso digital de forma inmediata para descargarlo y empezar hoy mismo.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tienes garantía de 7 días. Si no sientes que el material te sirve, puedes pedir la devolución.'
  }];
  return <Section className="bg-white" data-id="element-66">
      <div className="text-center mb-10" data-id="element-67">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-semibold mb-2 leading-tight" data-id="element-68">
          Preguntas frecuentes
        </h2>
        <p className="text-base sm:text-lg text-gray-500 italic" data-id="element-69">
          (léelas con honestidad)
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-70">
        {faqs.map((faq, i) => <FaqItem key={i} question={faq.q} answer={faq.a} data-id="element-71" />)}
      </div>
    </Section>;
};
const FaqItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-2xl overflow-hidden bg-gray-50" data-id="element-72">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none bg-white hover:bg-gray-50 transition-colors" data-id="element-73">
        <span className="font-bold text-lg text-brand-dark pr-4" data-id="element-74">
          {question}
        </span>
        <span className={`text-2xl text-brand-violet transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-75">
          ↓
        </span>
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 py-5 opacity-100' : 'max-h-0 py-0 opacity-0'}`} data-id="element-76">
        <p className="text-gray-700 text-lg leading-relaxed" data-id="element-77">{answer}</p>
      </div>
    </div>;
};